module.exports = __webpack_public_path__ + "img/help.57f43a6f.svg";